import React, { useContext } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { SnipcartContext } from "gatsby-plugin-snipcart-advanced/context"
import { FaShoppingCart } from "react-icons/fa"
import { GiDonut } from "react-icons/gi"

const Header = () => {
  const { state, user } = useContext(SnipcartContext)
  const { userStatus, cartQuantity } = state

  console.log(state, user)

  const DesktopLinks = (
    <Nav>
      <div className="flex-wrapper">
        <NavList>
          <li className="nav-link">
            <Link to="/">
              <GiDonut /> Home
            </Link>
          </li>
          <li className="nav-link">
            <Link to="/about">About</Link>
          </li>
          <li className="nav-link">
            <Link to="/menu">Menu</Link>
          </li>
          <li className="nav-link">
            <Link to="/contact">Contact</Link>
          </li>
        </NavList>
        <NavList>
          {userStatus === "SignedOut" ? (
            <li className="snipcart-customer-signin nav-link">
              <a>Login</a>
            </li>
          ) : (
            <li className="snipcart-customer-signin nav-link">
              <a>My Account</a>
            </li>
          )}
          <li className="snipcart-checkout nav-link">
            <a>
              <FaShoppingCart /> {cartQuantity}
            </a>
          </li>
        </NavList>
      </div>
    </Nav>
  )

  return <>{DesktopLinks}</>
}

export default Header

export const Nav = styled.div`
  /* position: fixed; */
  width: 100%;
  /* z-index: 11; */
  display: flex;
  justify-content: space-between;
  /* border-bottom: 1px solid white; */
  background-color: #304050;
  /* font-family: "Roboto"; */
  color: white;

  .flex-wrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`

export const NavList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 980px;

  .nav-link {
    /* background-color: #304050; */
    color: white;
    transition: 0.2s;
    /* font-size: 0.9rem; */
    cursor: pointer;
    text-align: center;
    justify-content: center;
    display: flex;
    border-style: none;
    font-size: 1.2rem;
    align-items: center;

    svg {
      margin-right: 0.5rem;
    }

    a {
      border-bottom: 2px solid transparent;
      &:hover {
        border-bottom: 2px solid white;
      }
      padding: 0.725rem;
      text-decoration: none;
      color: white;
      display: flex;
      align-items: center;
    }
  }
`
